import { FC } from 'react';
import { classNames } from '../../../utils';
import { HeaderHeightKey } from '../types/CardTypes';

enum HeaderHeight {
  'SMALL' = 'h-20',
  'LARGE' = 'h-64',
  'AUTO' = 'h-auto',
  'NONE' = 'h-0',
}

interface CardHeaderTemplateProps {
  headerHeight: HeaderHeightKey;
  withBorder?: boolean;
  children?: React.ReactNode;
}

const CardHeaderTemplate: FC<CardHeaderTemplateProps> = ({
  headerHeight,
  withBorder = true,
  children,
}) => {
  return (
    <div
      className={classNames(
        `flex flex-row items-center justify-between px-8 py-6 `,
        withBorder ? 'border-b border-gray-darkest border-opacity-10' : '',
        HeaderHeight[headerHeight],
      )}
    >
      {children}
    </div>
  );
};

export default CardHeaderTemplate;
